import { createContext, useContext, useState } from "react";

const translations = {
  es: {
    nav: { inicio: "Inicio", catalogo: "Catálogo", disena: "Diseña lo tuyo", proceso: "Proceso", juegos: "Juegos", galeria: "Galería", contacto: "Contacto", admin: "Admin" },
    seoText: {
      kicker: "Barranquilla · Atlántico · Colombia",
      title: "Impresión 3D sostenible en Barranquilla",
      p1: "Pame3D (Miss Pam Transforma) es un taller de impresión 3D en Barranquilla que convierte botellas PET recicladas en filamento y, con él, en juguetes educativos, figuras personalizadas y objetos para el hogar. Cada botella que rescatamos de las calles y playas del Atlántico se lava, se corta en tiras, se seca y se transforma en filamento rPET listo para imprimir capa por capa.",
      p2: "Diseñamos kits de animales articulados, juegos de mesa como el tablero de construcción, la hamburguesa para armar y la pizza enroscable, bandejas de motricidad fina y regalos únicos para graduaciones, cumpleaños y empresas. También fabricamos prótesis y ayudas técnicas para niños a través de nuestra línea social, sin costo para las familias que lo necesitan.",
      p3: "Trabajamos con familias, colegios y emprendimientos de Barranquilla, Soledad, Puerto Colombia y todo el Atlántico, y enviamos a cualquier ciudad de Colombia. Si buscas impresión 3D personalizada, juguetes ecológicos o un regalo con historia, escríbenos por WhatsApp o explora nuestro catálogo: cada producto nace de una botella y demuestra que el reciclaje puede convertirse en juego, aprendizaje y diseño.",
    },
    faq: {
      kicker: "Preguntas frecuentes",
      title: "Lo que más\nnos preguntan.",
      sub: "Envíos, tiempos, materiales y pedidos personalizados. Si tienes otra duda, escríbenos por WhatsApp.",
      items: [
        { q: "¿Hacen envíos en Barranquilla?", a: "Sí. Enviamos a Barranquilla y a toda Colombia. El envío tiene un costo de $11.000 COP y tarda aproximadamente 5 días hábiles desde que despachamos tu pedido. Te confirmamos la guía por WhatsApp." },
        { q: "¿Cuánto tarda mi pedido?", a: "Los productos del catálogo se imprimen bajo pedido en 3 a 5 días hábiles; después, el envío tarda alrededor de 5 días hábiles ($11.000 COP). Los encargos personalizados toman entre 5 y 10 días hábiles de producción según su complejidad; te confirmamos la fecha en la cotización." },
        { q: "¿De qué materiales están hechos los productos?", a: "Usamos filamento rPET fabricado por nosotros a partir de botellas recicladas y, cuando la pieza lo requiere (juegos y kits infantiles), PETG o PLA. Son materiales resistentes, sin BPA y se lavan con agua y jabón." },
        { q: "¿Puedo pedir un diseño personalizado?", a: "Claro. Hacemos figuras a partir de fotos, letreros, repuestos, prototipos y regalos corporativos. Entra a “Diseña lo tuyo”, describe tu idea, adjunta referencias y te enviamos una cotización en 24 a 48 horas." },
        { q: "¿Cómo puedo pagar?", a: "Con tarjeta de crédito o débito a través de Stripe, en pesos colombianos o dólares. Para encargos personalizados te enviamos un enlace de pago seguro cuando apruebes la cotización." },
        { q: "¿Los juguetes son seguros para niños?", a: "Sí. Las piezas son sólidas, sin bordes filosos y pensadas para manos pequeñas; los recomendamos a partir de 3 años con acompañamiento de un adulto. Los juegos incluyen tarjetas de actividades que puedes consultar en pame3d.com/juegos." },
      ],
    },
    game: {
      kicker: "Juego digital · Gratis",
      title: "Tablero digital",
      sub: "Elige una ficha, gírala y colócala sobre los pines. Copia las figuras de las tarjetas o inventa las tuyas, igual que con el tablero de verdad.",
      cards: "Ver tarjetas y retos", buy: "Comprar el tablero físico", retos: "Retos con tiempo",
      free: "Modo libre", copyThis: "Copia esta figura",
      piecesNeeded: "fichas en la tarjeta original. Puedes usar las que quieras: lo que cuenta es la forma.",
      download: "Descargar imagen", share: "Compartir por WhatsApp", downloaded: "Imagen guardada",
      shareText: "¡Mira la figura que armé en el Tablero Pame3D!",
      shareFallback: "Imagen descargada: adjúntala en el chat de WhatsApp que se abrió.", shareError: "No se pudo crear la imagen",
      rotate: "Girar", color: "Color", erase: "Quitar", undo: "Deshacer", clear: "Limpiar", hint: "Pista",
      success: "¡Lo lograste!", successSub: "La figura quedó igual a la tarjeta. Prueba otra o inventa la tuya.",
      pieces: "fichas en el tablero", tip: "Toca una ficha del panel y luego el tablero. Tecla R para girar.",
      seoTitle: "Tablero digital: arma figuras en pantalla | Pame3D",
      seoDesc: "Juega en línea con el tablero de construcción Pame3D: elige fichas, gíralas y copia más de 60 figuras: letras, números, dinosaurios y más. Gratis.",
    },
    burger: {
      title: "Hamburguesa digital",
      sub: "Elige un menú de las tarjetas y arma la hamburguesa tocando los ingredientes, de abajo hacia arriba. Si el orden queda igual a la tarjeta, ¡quedó lista!",
      buy: "Comprar la hamburguesa", menu: "Menú", order: "Lleva, de arriba hacia abajo:", layers: "capas apiladas",
      tip: "Toca un ingrediente para ponerlo encima.", works: "Qué trabaja.", wrong: "Mmm… ese no va ahí. Quita la última capa y prueba otra.",
      success: "¡Quedó igual!", successSub: "La hamburguesa coincide con el menú. Prueba otro menú o inventa el tuyo.",
      seoTitle: "Hamburguesa para armar: juego digital | Pame3D",
      seoDesc: "Arma en pantalla los 8 menús de la hamburguesa impresa en 3D de Pame3D: apila pan, carne, queso, tomate y lechuga en el orden correcto. Gratis para niños.",
    },
    pizza: {
      title: "Pizza digital",
      sub: "Elige un momento de las tarjetas, toca un ingrediente y luego la porción donde lo quieres enroscar. Cuando las cantidades coincidan, ¡ding!",
      buy: "Comprar la pizza", toppings: "ingredientes puestos", tip: "Toca un ingrediente y luego una porción.",
      needs: "Lleva:", freeMoment: "Momento de juego libre: no hay cantidades que cumplir.", works: "Qué trabaja.", full: "Esa porción ya está llena",
      success: "¡Ding! Pizza lista", successSub: "Las cantidades coinciden con la tarjeta. Sirve el pedido y prueba el siguiente momento.",
      seoTitle: "Pizza enroscable: juego digital | Pame3D",
      seoDesc: "Prepara en pantalla los 7 momentos de la pizza enroscable de Pame3D: cuenta pepperonis, quesos y piñas y ponlos en cada porción. Juego gratis para niños.",
    },
    retos: {
      kicker: "Misiones · 12 retos de las tarjetas", title: "Retos del tablero",
      sub: "Cada reto trae un objetivo, unas reglas y un tiempo. Pulsa Empezar, arma tu solución y toca ¡Listo! para ganar estrellas.",
      starsLabel: "estrellas", freeBoard: "Tablero libre", max: "máximo", start: "Empezar", done: "¡Listo!", retry: "Repetir", next: "Siguiente reto",
      peek: "Mirar otra vez (−1 estrella)", memorize: "Memoriza:", hide: "Ya la tengo", example: "Respuesta de ejemplo:",
      notYet: "Todavía no", timeUp: "¡Se acabó el tiempo!", perfect: "¡Perfecto!", good: "¡Bien hecho!", tryAgain: "Inténtalo otra vez",
      round: "Ronda", quizQ: "¿Dónde hay más fichas?", arriba: "Arriba", abajo: "Abajo", igual: "Igual", quizRight: "¡Correcto!", quizWrong: "Esta vez no.",
      quizCount: "Cuenta: arriba · abajo =", nextRound: "Siguiente ronda", seeResult: "Ver resultado", quizHits: "de 3 aciertos.",
    },
    gallery: {
      save: "Guardar en la galería", title: "Guarda tu creación", sub: "Escribe tu nombre (o el de tu peque) y la mostraremos en la galería del sitio.",
      namePh: "Tu nombre", submit: "Guardar", note: "Solo guardamos el nombre y la imagen del tablero. Miss Pam revisa la galería.",
      saved: "¡Guardada en la galería!", error: "No se pudo guardar. Intenta de nuevo.", doneTitle: "¡Ya está en la galería!", doneSub: "Tu creación quedó guardada con tu nombre.", view: "Ver la galería",
      kicker: "Hecho por niños", pageTitle: "Galería de creaciones", pageSub: "Figuras, hamburguesas, pizzas y retos que los niños armaron en los juegos digitales de Pame3D.",
      all: "Todas", games: { tablero: "Tablero", hamburguesa: "Hamburguesa", pizza: "Pizza", retos: "Retos" }, empty: "Aún no hay creaciones. ¡Sé el primero!", create: "Crear la mía", playIn: "Jugar:",
      like: "Me gusta", recent: "Recientes", mostLoved: "Más queridas",
      homeKicker: "Hecho por niños", homeTitle: "Las últimas\ncreaciones.", homeSub: "Figuras, hamburguesas y pizzas que los niños armaron en nuestros juegos digitales gratis. ¿Y la tuya?", homeCta: "Ver toda la galería", homePlay: "Jugar ahora",
    },
    diploma: {
      button: "Diploma", locked: "Completa los 12 retos para desbloquear tu diploma", ready: "¡Diploma desbloqueado!",
      title: "Diploma de Constructor", sub: "¡Completaste los 12 retos! Escribe el nombre que irá en el diploma.", doneSub: "Descárgalo o imprímelo y pégalo en la nevera.",
      namePh: "Nombre del constructor o constructora", submit: "Crear mi diploma", download: "Descargar", print: "Imprimir", changeName: "Cambiar nombre",
      error: "No se pudo crear el diploma", popup: "Permite las ventanas emergentes para imprimir",
    },
    offer: {
      kicker: "Impreso en 3D con botellas recicladas · Pame3D",
      buy: "Comprar", share: "Compartir por WhatsApp", copy: "Copiar enlace", copied: "Enlace copiado", copyError: "No se pudo copiar", shared: "Se abrió WhatsApp con el mensaje listo",
      shareText: "🧩 {name} — {price}. Juguete impreso en 3D con botellas recicladas por Pame3D (Barranquilla). Pruébalo gratis en pantalla y cómpralo aquí:",
      productShare: "Compartir", productShareText: "{name} — {price}. Impreso en 3D con botellas recicladas por Pame3D. Míralo aquí:",
    },
    contactPage: {
      title: "Hablemos de tu idea",
      sub: "Impresión 3D sostenible en Barranquilla. Escríbenos por el canal que prefieras y te respondemos el mismo día.",
      areaLabel: "Zona de servicio", area: "Barranquilla y Atlántico · Envíos a toda Colombia",
      h2: "¿Cómo trabajamos?",
      body: "Cuéntanos qué necesitas por WhatsApp o desde el formulario “Diseña lo tuyo”. Te enviamos una cotización en 24 a 48 horas, imprimimos tu pieza con material reciclado y la entregamos en Barranquilla o la despachamos a cualquier ciudad del país.",
      ctaWa: "Escribir por WhatsApp", ctaDisena: "Ir a Diseña lo tuyo",
    },
    hero: {
      kicker: "Impresión 3D · Ecológica y familiar",
      l1: "Cada producto",
      l2: "nace de",
      l3: "una botella.",
      sub: "Transformamos botellas PET recicladas en filamento y en juguetes educativos, figuras y objetos con propósito.",
      cta1: "Ver catálogo",
      cta2: "Diseña lo tuyo",
      bottles: "Botellas recicladas",
      products: "Productos creados",
    },
    marquee: "Botella → Tira → Filamento → Producto",
    manifesto: {
      title: "De la basura, belleza.",
      c1t: "Recolectamos", c1d: "Botellas PET que iban a terminar en ríos y calles se convierten en nuestra materia prima.",
      c2t: "Transformamos", c2d: "Cortamos las botellas en tiras, las secamos y las pultruimos hasta obtener filamento rPET listo para imprimir.",
      c3t: "Imprimimos", c3d: "Cada pieza se imprime capa por capa. Las líneas visibles no son un defecto: son la huella de una segunda vida.",
      c4t: "Educamos", c4d: "Nuestros kits de animales enseñan a los niños cómo se mueve la naturaleza — y por qué vale la pena cuidarla.",
    },
    featured: { kicker: "Catálogo", title: "Hecho de botellas,\nhecho con amor.", all: "Ver todo el catálogo" },
    social: {
      kicker: "Línea social",
      title: "Manos que ayudan a manitas",
      desc: "Imprimimos prótesis y ayudas técnicas para niños, sin costo para las familias que lo necesitan. Si conoces a un niño que podría beneficiarse, escríbenos.",
      cta: "Contáctanos",
    },
    processPreview: { kicker: "Nuestro proceso", title: "Del PET al producto", cta: "Conoce el proceso completo" },
    reviews: {
      kicker: "Comunidad",
      title: "Familias felices,\nplaneta feliz.",
      caption: "Talleres educativos con niños — así nace el amor por reciclar.",
    },
    catalog: {
      title: "Catálogo de diseños",
      sub: "Cada pieza lleva impresa una segunda oportunidad.",
      all: "Todos", kits: "Kits educativos", voladores: "Voladores", reptadores: "Reptadores",
      rodadores: "Rodadores", saltadores: "Saltadores", motricidad: "Motricidad fina", juegos: "Juegos", figuras: "Figuras personalizadas",
      hogar: "Hogar y oficina", social: "Línea social",
      gameCards: "Ver tarjetas, retos y actividades para jugar en casa", notFound: "No encontramos ese producto.",
      material: "Material", colors: "Colores disponibles", qty: "Cantidad",
      buy: "Comprar ahora", contact: "Solicitar información", free: "Sin costo",
      buying: "Redirigiendo a pago...",
      shipTitle: "Datos de envío",
      shipName: "Nombre completo", shipAddress: "Dirección", shipCity: "Ciudad", shipPhone: "Teléfono / WhatsApp",
      shipContinue: "Continuar al pago", shipBack: "Volver",
      shipRequired: "Completa todos los datos de envío",
      shipping: "Envío", shippingNote: "+ envío a toda Colombia", subtotal: "Subtotal", total: "Total a pagar", play: "Jugar en pantalla",
    },
    disena: {
      title: "Diseña lo tuyo",
      sub: "Cuéntanos qué necesitas y lo hacemos realidad en 3D con material reciclado.",
      desc: "Descripción del objeto", descPh: "Describe lo que necesitas: forma, detalles, texto, referencias...",
      files: "Imágenes o archivos de referencia", filesHint: "Fotos, bocetos o STL (máx. 5 archivos)",
      dims: "Medidas aproximadas", dimsPh: "Ej: 15cm de alto x 10cm de ancho",
      color: "Color", colorPh: "Ej: verde esmeralda",
      qty: "Cantidad", use: "Uso previsto", usePh: "Ej: regalo de graduación",
      date: "¿Para cuándo lo necesitas?",
      name: "Nombre", email: "Correo", phone: "Teléfono / WhatsApp", city: "Ciudad",
      submit: "Enviar solicitud", sending: "Enviando...",
      successTitle: "¡Solicitud recibida!",
      successMsg: "Te responderemos con una cotización en 24–48 horas.",
      another: "Enviar otra solicitud",
      required: "Completa los campos obligatorios",
    },
    proceso: {
      title: "Nuestro proceso",
      sub: "Cinco pasos separan una botella desechada de un producto con historia.",
      s1t: "Recolección de botellas", s1d: "Recuperamos botellas PET de hogares, colegios y puntos de acopio. Cada botella se lava y se le retira etiqueta y tapa.",
      s2t: "Corte en tiras", s2d: "Con una cortadora artesanal convertimos cada botella en una tira continua de PET de ancho constante — el primer paso de su transformación.",
      s3t: "Secado", s3d: "Las tiras se secan a temperatura controlada para eliminar la humedad. Un PET seco es la clave de un filamento fuerte.",
      s4t: "Pultrusión a filamento", s4d: "La tira pasa por una boquilla caliente que la funde y la estira hasta convertirla en filamento rPET de 1.75mm, listo para imprimir.",
      s5t: "Impresión 3D", s5d: "El filamento cobra vida capa por capa. De una botella promedio salen las alas de una mariposa o el cuerpo de un elefante articulado.",
    },
    contact: {
      title: "Hablemos",
      sub: "¿Tienes una idea, una pregunta o botellas para donar?",
      whatsapp: "WhatsApp", instagram: "Instagram", email: "Correo",
    },
    footer: { tagline: "Transformamos botellas en historias.", rights: "Todos los derechos reservados." },
    payment: {
      checking: "Verificando tu pago...",
      successTitle: "¡Gracias por tu compra!",
      successMsg: "Tu pedido nació de una botella reciclada. Te contactaremos pronto con los detalles de envío.",
      cancelTitle: "Pago cancelado",
      cancelMsg: "No se realizó ningún cobro. Tu carrito te espera.",
      back: "Volver al catálogo", home: "Ir al inicio",
      timeout: "No pudimos confirmar el pago. Escríbenos si el cobro se realizó.",
    },
  },
  en: {
    nav: { inicio: "Home", catalogo: "Catalog", disena: "Design yours", proceso: "Process", juegos: "Games", galeria: "Gallery", contacto: "Contact", admin: "Admin" },
    seoText: {
      kicker: "Barranquilla · Atlántico · Colombia",
      title: "Sustainable 3D printing in Barranquilla",
      p1: "Pame3D (Miss Pam Transforma) is a 3D printing workshop in Barranquilla that turns recycled PET bottles into filament and, from it, into educational toys, custom figures and home objects. Every bottle we rescue from the streets and beaches of Atlántico is washed, cut into strips, dried and transformed into rPET filament ready to print layer by layer.",
      p2: "We design articulated animal kits, board games such as the building board, the build-a-burger and the screw-on pizza, fine motor trays and one-of-a-kind gifts for graduations, birthdays and companies. Through our social line we also make prosthetics and assistive devices for children, free for the families who need them.",
      p3: "We work with families, schools and small businesses in Barranquilla, Soledad, Puerto Colombia and all of Atlántico, and we ship to any city in Colombia. If you are looking for custom 3D printing, eco-friendly toys or a gift with a story, message us on WhatsApp or explore our catalog: every product is born from a bottle and proves that recycling can become play, learning and design.",
    },
    faq: {
      kicker: "FAQ",
      title: "What people\nask us most.",
      sub: "Shipping, timing, materials and custom orders. Anything else? Message us on WhatsApp.",
      items: [
        { q: "Do you deliver in Barranquilla?", a: "Yes. We ship to Barranquilla and all of Colombia. Shipping costs $11,000 COP and takes about 5 business days from dispatch. We send you the tracking number on WhatsApp." },
        { q: "How long does my order take?", a: "Catalog products are printed to order in 3 to 5 business days; shipping then takes about 5 business days ($11,000 COP). Custom orders take 5 to 10 business days of production depending on complexity; we confirm the date in your quote." },
        { q: "What are the products made of?", a: "We use rPET filament we make ourselves from recycled bottles and, when the piece requires it (games and kids' kits), PETG or PLA. They are sturdy, BPA-free materials that wash with soap and water." },
        { q: "Can I order a custom design?", a: "Of course. We make figures from photos, signs, spare parts, prototypes and corporate gifts. Go to “Design yours”, describe your idea, attach references and we send a quote within 24 to 48 hours." },
        { q: "How can I pay?", a: "By credit or debit card through Stripe, in Colombian pesos or US dollars. For custom orders we send a secure payment link once you approve the quote." },
        { q: "Are the toys safe for children?", a: "Yes. Pieces are solid, with no sharp edges and designed for small hands; we recommend them from age 3 with adult supervision. The games include activity cards you can browse at pame3d.com/juegos." },
      ],
    },
    game: {
      kicker: "Digital game · Free",
      title: "Digital board",
      sub: "Pick a piece, rotate it and drop it on the pins. Copy the card figures or invent your own, just like with the real board.",
      cards: "See cards & challenges", buy: "Buy the physical board", retos: "Timed challenges",
      free: "Free play", copyThis: "Copy this figure",
      piecesNeeded: "pieces on the original card. Use any pieces you like: only the shape counts.",
      download: "Download image", share: "Share on WhatsApp", downloaded: "Image saved",
      shareText: "Look at the figure I built on the Pame3D board!",
      shareFallback: "Image downloaded: attach it in the WhatsApp chat that just opened.", shareError: "Could not create the image",
      rotate: "Rotate", color: "Color", erase: "Remove", undo: "Undo", clear: "Clear", hint: "Hint",
      success: "You did it!", successSub: "Your figure matches the card. Try another one or invent your own.",
      pieces: "pieces on the board", tip: "Tap a piece in the panel, then the board. Press R to rotate.",
      seoTitle: "Digital board: build figures on screen | Pame3D",
      seoDesc: "Play online with the Pame3D building board: pick pieces, rotate them and copy 60+ figures: letters, numbers, dinosaurs and more. Free.",
    },
    burger: {
      title: "Digital burger",
      sub: "Pick a menu from the cards and build the burger by tapping ingredients, bottom to top. If the order matches the card, it's ready!",
      buy: "Buy the burger", menu: "Menu", order: "Top to bottom:", layers: "stacked layers",
      tip: "Tap an ingredient to stack it on top.", works: "Skills.", wrong: "Hmm… that one doesn't go there. Remove the last layer and try another.",
      success: "It matches!", successSub: "Your burger matches the menu. Try another menu or invent your own.",
      seoTitle: "Build-a-burger: digital game | Pame3D",
      seoDesc: "Build the 8 menus of the Pame3D 3D-printed burger on screen: stack bun, patty, cheese, tomato and lettuce in the right order. Free for kids.",
    },
    pizza: {
      title: "Digital pizza",
      sub: "Pick a moment from the cards, tap an ingredient and then the slice where you want to screw it on. When the amounts match, ding!",
      buy: "Buy the pizza", toppings: "toppings placed", tip: "Tap an ingredient, then a slice.",
      needs: "Needs:", freeMoment: "Free play moment: no amounts to match.", works: "Skills.", full: "That slice is full",
      success: "Ding! Pizza ready", successSub: "The amounts match the card. Serve the order and try the next moment.",
      seoTitle: "Screw-on pizza: digital game | Pame3D",
      seoDesc: "Prepare the 7 moments of the Pame3D screw-on pizza on screen: count pepperoni, cheese and pineapple and place them on each slice. Free game for kids.",
    },
    retos: {
      kicker: "Missions · 12 card challenges", title: "Board challenges",
      sub: "Each challenge has a goal, rules and a timer. Press Start, build your solution and tap Done! to earn stars.",
      starsLabel: "stars", freeBoard: "Free board", max: "max", start: "Start", done: "Done!", retry: "Retry", next: "Next challenge",
      peek: "Peek again (−1 star)", memorize: "Memorize:", hide: "Got it", example: "Example answer:",
      notYet: "Not yet", timeUp: "Time's up!", perfect: "Perfect!", good: "Well done!", tryAgain: "Try again",
      round: "Round", quizQ: "Where are there more pieces?", arriba: "Top", abajo: "Bottom", igual: "Same", quizRight: "Correct!", quizWrong: "Not this time.",
      quizCount: "Count: top · bottom =", nextRound: "Next round", seeResult: "See result", quizHits: "of 3 correct.",
    },
    gallery: {
      save: "Save to gallery", title: "Save your creation", sub: "Type your name (or your kid's) and we'll show it in the site gallery.",
      namePh: "Your name", submit: "Save", note: "We only store the name and the board image. Miss Pam reviews the gallery.",
      saved: "Saved to the gallery!", error: "Could not save. Try again.", doneTitle: "It's in the gallery!", doneSub: "Your creation was saved with your name.", view: "See the gallery",
      kicker: "Made by kids", pageTitle: "Creations gallery", pageSub: "Figures, burgers, pizzas and challenges kids built in Pame3D's digital games.",
      all: "All", games: { tablero: "Board", hamburguesa: "Burger", pizza: "Pizza", retos: "Challenges" }, empty: "No creations yet. Be the first!", create: "Create mine", playIn: "Play:",
      like: "Like", recent: "Recent", mostLoved: "Most loved",
      homeKicker: "Made by kids", homeTitle: "The latest\ncreations.", homeSub: "Figures, burgers and pizzas kids built in our free digital games. What about yours?", homeCta: "See the whole gallery", homePlay: "Play now",
    },
    diploma: {
      button: "Diploma", locked: "Complete all 12 challenges to unlock your diploma", ready: "Diploma unlocked!",
      title: "Builder Diploma", sub: "You completed the 12 challenges! Type the name for the diploma.", doneSub: "Download or print it and stick it on the fridge.",
      namePh: "Builder's name", submit: "Create my diploma", download: "Download", print: "Print", changeName: "Change name",
      error: "Could not create the diploma", popup: "Allow pop-ups to print",
    },
    offer: {
      kicker: "3D printed from recycled bottles · Pame3D",
      buy: "Buy", share: "Share on WhatsApp", copy: "Copy link", copied: "Link copied", copyError: "Could not copy", shared: "WhatsApp opened with the message ready",
      shareText: "🧩 {name} — {price}. 3D-printed toy made from recycled bottles by Pame3D (Barranquilla). Try it free on screen and buy it here:",
      productShare: "Share", productShareText: "{name} — {price}. 3D printed from recycled bottles by Pame3D. See it here:",
    },
    contactPage: {
      title: "Let's talk about your idea",
      sub: "Sustainable 3D printing in Barranquilla. Reach us on whichever channel you prefer and we reply the same day.",
      areaLabel: "Service area", area: "Barranquilla & Atlántico · Shipping across Colombia",
      h2: "How we work",
      body: "Tell us what you need on WhatsApp or through the “Design yours” form. We send a quote within 24 to 48 hours, print your piece with recycled material and deliver it in Barranquilla or ship it to any city in the country.",
      ctaWa: "Message on WhatsApp", ctaDisena: "Go to Design yours",
    },
    hero: {
      kicker: "3D Printing · Eco-friendly & family-first",
      l1: "Every product",
      l2: "is born from",
      l3: "a bottle.",
      sub: "We transform recycled PET bottles into filament and into educational toys, figures and objects with purpose.",
      cta1: "View catalog",
      cta2: "Design yours",
      bottles: "Bottles recycled",
      products: "Products created",
    },
    marquee: "Bottle → Strip → Filament → Product",
    manifesto: {
      title: "From waste, beauty.",
      c1t: "We collect", c1d: "PET bottles that would end up in rivers and streets become our raw material.",
      c2t: "We transform", c2d: "We cut bottles into strips, dry them and pultrude them into rPET filament ready for printing.",
      c3t: "We print", c3d: "Each piece is printed layer by layer. Visible lines are not a defect: they are the fingerprint of a second life.",
      c4t: "We educate", c4d: "Our animal kits teach children how nature moves — and why it's worth protecting.",
    },
    featured: { kicker: "Catalog", title: "Made from bottles,\nmade with love.", all: "View full catalog" },
    social: {
      kicker: "Social line",
      title: "Hands helping little hands",
      desc: "We print prosthetics and assistive devices for children, free for families in need. If you know a child who could benefit, write to us.",
      cta: "Contact us",
    },
    processPreview: { kicker: "Our process", title: "From PET to product", cta: "See the full process" },
    reviews: {
      kicker: "Community",
      title: "Happy families,\nhappy planet.",
      caption: "Educational workshops with kids — this is how the love for recycling is born.",
    },
    catalog: {
      title: "Design catalog",
      sub: "Every piece carries a printed second chance.",
      all: "All", kits: "Educational kits", voladores: "Flyers", reptadores: "Crawlers",
      rodadores: "Rollers", saltadores: "Jumpers", motricidad: "Fine motor", juegos: "Games", figuras: "Custom figures",
      hogar: "Home & office", social: "Social line",
      gameCards: "See cards, challenges and activities to play at home", notFound: "We couldn't find that product.",
      material: "Material", colors: "Available colors", qty: "Quantity",
      buy: "Buy now", contact: "Request info", free: "Free of charge",
      buying: "Redirecting to payment...",
      shipTitle: "Shipping details",
      shipName: "Full name", shipAddress: "Address", shipCity: "City", shipPhone: "Phone / WhatsApp",
      shipContinue: "Continue to payment", shipBack: "Back",
      shipRequired: "Please complete all shipping details",
      shipping: "Shipping", shippingNote: "+ shipping across Colombia", subtotal: "Subtotal", total: "Total to pay", play: "Play on screen",
    },
    disena: {
      title: "Design yours",
      sub: "Tell us what you need and we'll make it real in 3D with recycled material.",
      desc: "Object description", descPh: "Describe what you need: shape, details, text, references...",
      files: "Reference images or files", filesHint: "Photos, sketches or STL (max. 5 files)",
      dims: "Approximate dimensions", dimsPh: "E.g.: 15cm tall x 10cm wide",
      color: "Color", colorPh: "E.g.: emerald green",
      qty: "Quantity", use: "Intended use", usePh: "E.g.: graduation gift",
      date: "When do you need it?",
      name: "Name", email: "Email", phone: "Phone / WhatsApp", city: "City",
      submit: "Send request", sending: "Sending...",
      successTitle: "Request received!",
      successMsg: "We'll get back to you with a quote in 24–48 hours.",
      another: "Send another request",
      required: "Please complete the required fields",
    },
    proceso: {
      title: "Our process",
      sub: "Five steps separate a discarded bottle from a product with a story.",
      s1t: "Bottle collection", s1d: "We recover PET bottles from homes, schools and collection points. Each bottle is washed and stripped of label and cap.",
      s2t: "Strip cutting", s2d: "With an artisanal cutter we turn each bottle into a continuous PET strip of constant width — the first step of its transformation.",
      s3t: "Drying", s3d: "Strips are dried at controlled temperature to remove moisture. Dry PET is the key to strong filament.",
      s4t: "Pultrusion to filament", s4d: "The strip passes through a hot nozzle that melts and stretches it into 1.75mm rPET filament, ready to print.",
      s5t: "3D printing", s5d: "The filament comes to life layer by layer. An average bottle yields a butterfly's wings or an articulated elephant's body.",
    },
    contact: {
      title: "Let's talk",
      sub: "Got an idea, a question or bottles to donate?",
      whatsapp: "WhatsApp", instagram: "Instagram", email: "Email",
    },
    footer: { tagline: "We transform bottles into stories.", rights: "All rights reserved." },
    payment: {
      checking: "Verifying your payment...",
      successTitle: "Thank you for your purchase!",
      successMsg: "Your order was born from a recycled bottle. We'll contact you soon with shipping details.",
      cancelTitle: "Payment cancelled",
      cancelMsg: "No charge was made. Your cart is waiting.",
      back: "Back to catalog", home: "Go home",
      timeout: "We couldn't confirm the payment. Contact us if you were charged.",
    },
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState("es");
  const [currency, setCurrency] = useState("cop");
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, currency, setCurrency, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);

export const SHIPPING = { cop: 11000, usd: 3 };

export const fmtMoney = (v, currency) =>
  currency === "usd" ? `$${v.toLocaleString("en-US")} USD` : `$${v.toLocaleString("es-CO")} COP`;

export const fmtPrice = (product, currency) => {
  const v = currency === "usd" ? product.price_usd : product.price_cop;
  if (v == null) return null;
  return currency === "usd"
    ? `$${v.toLocaleString("en-US")} USD`
    : `$${v.toLocaleString("es-CO")} COP`;
};
